import {removeLoadingState, setVisibility} from "../helpers";

export function initProformaPage(){
    const form = document.getElementById("proforma-form");
    const validationBox = document.getElementById("proforma-validation-message");
    const checkboxInput = form.querySelectorAll('input[type="checkbox"]');
    if(!form || !validationBox || !checkboxInput) return;
    
    form.addEventListener("sds:form:beforeSubmit", handleFormSubmit);
    
    function handleFormSubmit(e) {
        setVisibility(validationBox, false);
        const checkedBoxes = [...checkboxInput].filter(i => i.checked);
        
        if(checkedBoxes.length === 0){
            setVisibility(validationBox, true);
            // add an eventlistner to the change event of the form so the validation works afterwards.
            form.addEventListener('change', handleValidationBox);
            removeLoadingState(e.detail.submitter);
            e.preventDefault();
        }
    }
    
    function handleValidationBox() {
        const checkedBoxes = [...checkboxInput].filter(i => i.checked);
        setVisibility(validationBox, checkedBoxes.length === 0);
    }
}